import { FC, useContext, useState } from "react";
import NotificationDispatch, {
  showErrorNotification,
  showSuccessNotification,
} from "../../../context/notificationContext";
import { useI18n } from "../../../hooks/useTranslations";
import { useClaimTypesApi } from "../../../http/claimTypes/api";
import { UpsertClaimType } from "../../../http/claimTypes/types";
import SvgAdd from "../../icons/Add";
import Button from "../../ui/Button";
import ModalDialog from "../../ui/ModalDialog";
import ClaimTypeForm, { ClaimTypeFormBody } from "./ClaimTypeForm";

const CreateClaimTypeButton: FC = () => {
  const i18n = useI18n();
  const [show, setShow] = useState(false);
  const dispatch = useContext(NotificationDispatch);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const claimTypesApi = useClaimTypesApi();

  const onSubmit = async (formData: ClaimTypeFormBody) => {
    const body: UpsertClaimType = {
      name: formData.name ?? "",
    };

    setIsSubmitting(true);
    try {
      await claimTypesApi.insertAdminClaimType(body);
      dispatch(showSuccessNotification(i18n.t));
      setShow(false);
    } catch (error) {
      dispatch(showErrorNotification(i18n, error));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Button buttonProps={{ onClick: () => setShow(true) }} glyph={SvgAdd} />
      {!!show && (
        <ModalDialog onClose={() => setShow(false)} title={i18n.t.claimTypes.new}>
          <ClaimTypeForm isDisabled={isSubmitting} onSubmit={onSubmit} />
        </ModalDialog>
      )}
    </>
  );
};

export default CreateClaimTypeButton;
